import { useCallback, useEffect, useMemo, useState } from 'react';
import { selectCanvasAnalysisPayload } from '../../projection/canvas/canvasAnalysisPayloadSelector.js';
import { selectCurrentIntakeCanvasProjection } from '../../projection/canvas/currentArtifactProjectionSelector.js';
import {
  resolveComposerActiveArtifactTarget,
  resolveComposerActiveArtifactTargetKey,
} from '../../projection/composer/active-artifact-target.js';

export function useComposerActiveArtifactTarget(options) {
  const {
    activeSessionId,
    canvasActiveTabKey,
    canvasTabLabelsByKey,
    canvasTargetFocusKey,
    sessionContext,
    showCanvasPanel,
  } = {
    activeSessionId: '',
    canvasActiveTabKey: '',
    canvasTabLabelsByKey: {},
    canvasTargetFocusKey: 0,
    composerModeKey: '',
    sessionContext: null,
    showCanvasPanel: false,
    timelineItems: [],
    ...options,
  };
  const resolvedTarget = useMemo(() => resolveComposerActiveArtifactTarget({
    canvasActiveTabKey,
    canvasTabLabelsByKey,
    canvasAnalysisPayload: selectCanvasAnalysisPayload({ sessionContext }),
    intakeCanvasState: selectCurrentIntakeCanvasProjection({ sessionContext: sessionContext ?? {}, canvasActiveTabKey }),
    showCanvasPanel,
  }), [canvasActiveTabKey, canvasTabLabelsByKey, sessionContext, showCanvasPanel]);
  const targetKey = useMemo(
    () => resolveComposerActiveArtifactTargetKey(resolvedTarget),
    [resolvedTarget],
  );
  const [dismissedTarget, setDismissedTarget] = useState({ focusKey: 0, targetKey: '' });
  useEffect(() => {
    setDismissedTarget({ focusKey: 0, targetKey: '' });
  }, [activeSessionId]);
  useEffect(() => {
    if (dismissedTarget.targetKey && dismissedTarget.targetKey !== targetKey) {
      setDismissedTarget({ focusKey: 0, targetKey: '' });
    }
  }, [dismissedTarget.targetKey, targetKey]);
  const targetDismissed = Boolean(
    targetKey
    && dismissedTarget.targetKey === targetKey
    && dismissedTarget.focusKey === canvasTargetFocusKey
  );
  const activeArtifactTarget = targetDismissed ? null : resolvedTarget;
  const dismissActiveArtifactTarget = useCallback(() => {
    if (targetKey) {
      setDismissedTarget({ focusKey: canvasTargetFocusKey, targetKey });
    }
  }, [canvasTargetFocusKey, targetKey]);
  return { activeArtifactTarget, dismissActiveArtifactTarget };
}

export default useComposerActiveArtifactTarget;
